import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import React from "react";

export default function DashboardPage({
  children,
  renderNavbar = true,
  layoutPadding = 3,
  showBreadcrumbs = false,
  showNavbarOnAllScreens = false,
  breadcrumbAction,
}: {
  children: React.ReactNode;
  renderNavbar?: boolean;
  layoutPadding?: number;
  showBreadcrumbs?: boolean;
  showNavbarOnAllScreens?: boolean;
  breadcrumbAction?: React.ReactNode;
}) {
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          "@media print": {
            display: "none",
          },
        }}
        display={showNavbarOnAllScreens ? "block" : { sx: "block", xl: "none" }}
      >
        <DashboardNavbar
          showBreadcrumbs={showBreadcrumbs}
          renderNavbar={renderNavbar}
          breadcrumbAction={breadcrumbAction}
        />
      </MDBox>
      <MDBox my={3}>
        <Card>
          <MDBox p={layoutPadding}>{children}</MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
